enum SESSION_KEYS {
  ACCESS_TOKEN = "access_token",
  REFRESH_TOKEN = "refresh_token",
  LOGGED_USER_COMPANY = "logged_user_company",
  IS_RESETTING_PASSWORD = "is_resetting_password",
}

export default SESSION_KEYS
